// extracted by mini-css-extract-plugin
module.exports = {"compactWrapper":"ReceiverLocationSelector_compactWrapper__2YNr4","receiverLocation":"ReceiverLocationSelector_receiverLocation__6braS"};